import React, { useEffect, useState } from "react";
import "../Pages/card.scss";
import Card from "../Components/Card";
import { TagButton, TagButtonAll } from "../Components/TagButtons";
import kitchen from "../assets/Inna/6.jpg";
import hall from "../assets/Inna/4.jpg";
import bedroom from "../assets/Inna/12.jpg";
import study from "../assets/Inna/17.jpg";
import bathroom from "../assets/Inna/25.jpg";
import hallway from "../assets/Inna/19.jpg";
import wardrobe from "../assets/Inna/27.jpg";
import plan from "../assets/Inna/plan.jpg";
import flat from "../Components/data.json";
import { useCallback } from "react";
import Gallery from "../Components/GalleryViewer";
import { Translation } from "react-i18next";

const images = flat;

const mainCardsData = [
  {
    img: kitchen,
    alt: "kitchen",
    titleKey: "portfolio.title-1",
    descKey: "portfolio.description",
    tagName: "кухня",
  },
  {
    img: hall,
    alt: "hall",
    titleKey: "portfolio.title-2",
    descKey: "portfolio.description-2",
    tagName: "гостиная",
  },
  {
    img: bedroom,
    alt: "bedroom",
    titleKey: "portfolio.title-3",
    descKey: "portfolio.description-3",
    tagName: "спальня",
  },
  {
    img: study,
    alt: "cabinet",
    titleKey: "portfolio.title-5",
    descKey: "portfolio.description-5",
    tagName: "кабинет",
  },
  {
    img: bathroom,
    alt: "bathroom",
    titleKey: "portfolio.title-6",
    descKey: "portfolio.description-6",
    tagName: "ванная",
  },
  {
    img: wardrobe,
    alt: "wardrobe",
    titleKey: "portfolio.title-7",
    descKey: "portfolio.description-7",
    tagName: "гардеробная",
  },
  {
    img: hallway,
    alt: "hallway",
    titleKey: "portfolio.title-8",
    descKey: "portfolio.description-8",
    tagName: "прихожая",
  },
  {
    img: plan,
    alt: "plan",
    titleKey: "portfolio.title-11",
    descKey: "portfolio.description-11",
    tagName: "планировка",
  },
];

function FlatThree() {
  const [tag, setTag] = useState("all");
  const [filteredImages, setFilteredImages] = useState([]);

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  useEffect(() => {
    tag === "all"
      ? setFilteredImages(images.flat_3)
      : setFilteredImages(images.flat_3.filter((image) => image.tag === tag));
  }, [tag]);

  useEffect(() => {
    if (isViewerOpen) {
      document.body.classList.add("viewer-open");
    } else {
      document.body.classList.remove("viewer-open");
    }
  }, [isViewerOpen]);

  return (
    <Translation>
      {(t) => (
        <div
          style={{
            fontWeight: "bold",
            fontFamily: "Montserrat, sans-serif",
            textAlign: "center",
            color: "#46669c",
          }}
        >
          <h5
            style={{ fontWeight: "600", marginLeft: "1em", marginRight: "1em" }}
          >
            {t(["portfolio.adres-3"])}
            {/*  Visualization and interior layout of the apartment. Krivoy Rog,
            Nemetska str. */}
          </h5>
          <div className="wrapper mt-4">
            {mainCardsData.map((card, index) => (
              <div
                className="card"
                key={index}
                style={{ fontFamily: "Montserrat, sans-serif" }}
              >
                <Card
                  img={card.img}
                  alt={card.alt}
                  title={t([card.titleKey])}
                  description={t([card.descKey])}
                />
                <div onClick={() => openImageViewer(0)}>
                  <TagButton
                    name={card.tagName}
                    tagactive={tag === card.tagName}
                    handleSetTag={setTag}
                  />
                </div>
              </div>
            ))}
          </div>

          <div onClick={() => openImageViewer(0)}>
            <TagButtonAll
              name="all"
              tagactive={tag === "all" ? true : false}
              handleSetTag={setTag}
            />
          </div>

          <div>
            {isViewerOpen && (
              <Gallery
                images={filteredImages}
                startIndex={currentImage}
                onClose={closeImageViewer}
              />
            )}
          </div>
        </div>
      )}
    </Translation>
  );
}

export default FlatThree;
